var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedImoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8_16",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2476 0.5H0.247559V32.5H32.2476V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2476 28.5C22.875 28.5 28.2476 23.1274 28.2476 16.5C28.2476 9.87258 22.875 4.5 16.2476 4.5C9.62018 4.5 4.2476 9.87258 4.2476 16.5C4.2476 23.1274 9.62018 28.5 16.2476 28.5Z",
    fill: "#B0022E",
    stroke: "#B0022E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9141 15.1665C14.0187 15.1665 14.9141 14.2711 14.9141 13.1665C14.9141 12.0619 14.0187 11.1665 12.9141 11.1665C11.8095 11.1665 10.9141 12.0619 10.9141 13.1665C10.9141 14.2711 11.8095 15.1665 12.9141 15.1665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5811 15.1665C20.6857 15.1665 21.5811 14.2711 21.5811 13.1665C21.5811 12.0619 20.6857 11.1665 19.5811 11.1665C18.4765 11.1665 17.5811 12.0619 17.5811 13.1665C17.5811 14.2711 18.4765 15.1665 19.5811 15.1665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1967 21.3087C20.5232 19.9243 18.4193 19.1668 16.2474 19.1668C14.0755 19.1668 11.9716 19.9243 10.2981 21.3087",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedImoji);
export default __webpack_public_path__ + "static/media/redImoji.1587e05e367d5331d2038cd3f99acefa.svg";
export { ForwardRef as ReactComponent };